export const countryList = {
  Russia: {
    vat: 20,
  },
  Norway: {
    vat: 25,
  },
  Finland: {
    vat: 25.5,
  },
  Sweden: {
    vat: 25,
  },
  Iceland: {
    vat: 24,
  },
  Estonia: {
    vat: 24,
  },
  "United Kingdom": {
    vat: 5,
  },
  Latvia: {
    vat: 0,
  },
  Denmark: {
    vat: 25,
  },
  Belarus: {
    vat: 20,
  },
  Lithuania: {
    vat: 0,
  },
  Ireland: {
    vat: 9,
  },
  "Northern Ireland": {
    vat: 20,
  },
  Poland: {
    vat: 23,
  },
  Germany: {
    vat: 19,
  },
  Luxembourg: {
    vat: 17,
  },
  Ukraine: {
    vat: 20,
  },
  Netherlands: {
    vat: 21,
  },
  Belgium: {
    vat: 6,
  },
  France: {
    vat: 20,
  },
  "Czech Republic": {
    vat: 21,
  },
  Slovakia: {
    vat: 20,
  },
  Moldova: {
    vat: 20,
  },
  Romania: {
    vat: 19,
  },
  Hungary: {
    vat: 27,
  },
  Austria: {
    vat: 20,
  },
  Switzerland: {
    vat: 0,
  },
  Italy: {
    vat: 10,
  },
  Malta: {
    vat: 5,
  },
  Slovenia: {
    vat: 22,
  },
  Croatia: {
    vat: 13,
  },
  Serbia: {
    vat: 20,
  },
  Bulgaria: {
    vat: 20,
  },
  "Bosnia-Hertsegovina": {
    vat: 20,
  },
  Turkey: {
    vat: 20,
  },
  Cyprus: {
    vat: 20,
  },
  Spain: {
    vat: 5,
  },
  Montenegro: {
    vat: 21,
  },
  Kosovo: {
    vat: 20,
  },
  Portugal: {
    vat: 23,
  },
  "North Macedonia": {
    vat: 18,
  },
  Greece: {
    vat: 6,
  },
  Albania: {
    vat: 20,
  },
};
